
import { Vue, servicesURL, cookies, webClientID, requestHeaders, getCookie, headers } from '../../constants/constants'
import FormFeedback from '../common/FormFeedback.vue'
import axios from 'axios';
import { staticContent } from '../../localisation/detect-lang';

export default Vue.component('change-password', {
	components: {
		'form-feedback': FormFeedback
	},
	data () {
		return {
			staticContent,
			oldPassword: '',
			newPassword: '',
			newRePassword: '',
			passwordDisplayState : { oldPassword: false, newPassword: false, newRePassword: false },
			loading: false,
		}
	},
	computed: {
		signupErrors(){
			return this.$store.getters.getSignupErrors
		}
	},
	methods: {
		togglePasswordDisplayState (property) {
			this.passwordDisplayState[property] = !this.passwordDisplayState[property]
		},
		clearErrors () {
			this.$refs.feedback.clear()
		},
		submitChangePassword () {
			this.loading = true
			this.clearErrors();
			axios({
        		method: 'PUT',
				url: servicesURL.user.changePassword,
				headers,
				data: JSON.stringify({
					password: this.oldPassword,
					newPassword: this.newPassword
				})
			})
			.then(res => {
				this.$refs.feedback.showSuccess('Password changed successfully')

				//complete
				this.loading = false
			})
			.catch(error => {
				console.log("error", error.response.data.description)
				this.loading = false
				this.$refs.feedback.showError(
					error.response.data.errorCode == "SYS-002"?staticContent.restaurant.userProfile.oldPassError:
					staticContent.restaurant.userProfile.genericError)
			})
		}
	}
})
